module.exports = __webpack_public_path__ + "img/2.ce08a043.png";